import React, { useState, useEffect } from 'react';
import { Button, Tooltip, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Autocomplete, TextField, Typography, CircularProgress } from '@mui/material';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import InfoBox from './InfoBox'
import moment from 'moment';
import axios from 'axios';
import { env, APIURL } from '../../config'

export default function ConDetails(props) {
    const [open, setOpen] = useState(false);
    const [AH_Dialog, setAH_Dialog] = useState(false);
    const [contactEmail, setContactEmail] = useState(null);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customerEmail, setCustomerEmail] = useState(null);
    const [customerName, setCustomerName] = useState(null);
    const [sendingInvite, setSendingInvite] = useState(false);
    const [AH_Invites, setAH_Invites] = useState([]);

    useEffect(() => {
        setContactEmail(props.data.con_email);

        if (props.data.con_email?.trim()) {
            fetchInvites(props.data.con_email)
        }
    }, [props]);

    const fetchInvites = async (email) => {
        await axios
            .get(APIURL + "/ability_hub/getInvites", {
                params: { userEmail: email }
            }).then((response) => {
                setAH_Invites(response.data);
            }).catch((error) => {
                console.log(error);
            });
    };

    const handleDelConfirmModal = () => {
        setOpen(!open);
    }

    const validateEmail = (value) => {
        if (!value) return true;
        if (!/\S+@\S+\.\S+/.test(value)) return false;
        return true;
    }

    const handleInvite = async () => {
        setSendingInvite(true);

        if (contactEmail?.trim() !== props.data.con_email?.trim()) {
            await axios.put(APIURL + '/contacts/email', {
                con_id: props.data.con_id,
                con_email: contactEmail
            }).then((response) => {
                console.log(response);
            }).catch((error) => {
                console.log(error);
            });
        }

        if (customerEmail?.trim() !== selectedCustomer.cus_email?.trim()) {
            await axios.put(APIURL + '/customers/email', {
                cus_id: selectedCustomer.cus_id,
                cus_email: customerEmail
            }).then((response) => {
                console.log(response);
            }).catch((error) => {
                console.log(error);
            });
        }

        await axios.post(APIURL + "/ability_hub", {
            compName: props.user.company_name,
            empEmail: props.user.sec_email,
            empName: props.user.emp_name,
            cusEmail: customerEmail,
            cusName: customerName,
            conEmail: contactEmail,
            conName: props.data.con_first_name + ' ' + props.data.con_last_name,
            inviteType: 'Contact',
            customer_id: selectedCustomer.cus_id,
        }).then((response) => {
            console.log(response);
        }).catch((error) => {
            console.log(error);
        });

        props.fetchData();
        handleCloseAH_Dialog();
        setSendingInvite(false);
    }

    const handleCloseAH_Dialog = () => {
        setAH_Dialog(false);
        setContactEmail(props.data.con_email);
        setSelectedCustomer(null);
        setCustomerEmail(null);
    }

    return (
        <div style={{ backgroundColor: '#fafafa' }} className="jumbotron jumbotron-fluid pt-1 pb-1">
            {
                <Dialog open={AH_Dialog} onClose={() => { handleCloseAH_Dialog(); }}>
                    <DialogTitle sx={{ width: '100%', textAlign: 'center', borderBottom: '1px solid lightgray' }}>
                        Invite <span style={{ color: '#1976D2' }}>{props.data.con_first_name} {props.data.con_last_name}</span> to Ability Hub
                    </DialogTitle>
                    <DialogContent>
                        <TextField
                            label="Invite From"
                            value={props.user.sec_email}
                            sx={{ marginTop: 2, marginBottom: 2 }}
                            size="small"
                            fullWidth
                            disabled
                        />
                        <TextField
                            label="Invite To"
                            value={contactEmail}
                            onChange={(event) => setContactEmail(event.target.value)}
                            size="small"
                            fullWidth
                            error={!validateEmail(contactEmail)}
                        />
                        {!validateEmail(contactEmail) && <Typography color="error">Please enter a valid email</Typography>}
                        <Autocomplete
                            id="client-select"
                            options={props.customerList}
                            getOptionLabel={(option) => option.cus_name}
                            onChange={(event, value) => { setSelectedCustomer(value); setCustomerName(value?.cus_name ?? ''); setCustomerEmail(value?.cus_email ?? ''); }}
                            renderOption={(props, option) => (
                                <li {...props} key={option.cus_id}>
                                    {option.cus_name}
                                </li>
                            )}
                            renderInput={(params) => <TextField {...params} sx={{ marginTop: 2, marginBottom: 2 }} label="Select Related Customer" />}
                            size="small"
                        />
                        {selectedCustomer &&
                            <div>
                                <TextField
                                    label="Customer Email"
                                    value={customerEmail}
                                    onChange={(event) => setCustomerEmail(event.target.value)}
                                    size="small"
                                    fullWidth
                                    error={!validateEmail(customerEmail)}
                                />
                                {!validateEmail(customerEmail) && <Typography color="error">Please enter a valid email</Typography>}
                            </div>
                        }
                        <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            sx={{ marginTop: 2 }}
                            onClick={() => { handleInvite(); }}
                            disabled={sendingInvite || !contactEmail || !customerEmail || !validateEmail(props.user.sec_email && contactEmail && customerEmail) || env === 'test'}
                        >
                            {sendingInvite ? (
                                <CircularProgress size={24} color="inherit" />
                            ) : (
                                'Invite'
                            )}
                        </Button>
                    </DialogContent>
                </Dialog>
            }
            <Dialog open={open} onClose={handleDelConfirmModal}>
                <DialogTitle>Delete Contact</DialogTitle>
                <DialogContent sx={{ textAlign: 'center' }}>Are you sure you want to delete this contact?</DialogContent>
                <DialogActions sx={{ justifyContent: 'center', mb: 1 }}>
                    <Button className='mr-5' variant="outlined" onClick={handleDelConfirmModal}>
                        Back
                    </Button>
                    <Button variant="contained" color="error" onClick={() => { props.onDel(props.data.con_id); handleDelConfirmModal(); }}>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
            <InfoBox user={props.user} data={props.data} AH_Invites={AH_Invites} />
        </div>
    );
};